var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


export {$ac91fc9fe02f71f6$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
